__turbopack_context__.v({
  "className": "sEYq4W_className",
  "variable": "sEYq4W_variable",
});
